import { useState, useEffect } from 'react'
import { api } from 'core/api/ConnectionManager'
import { palette } from 'theme/tokens/palette'
import { defaultThemeStyles as defaultThemeDashboardStyles } from 'organisms/Dashboard/Dashboard-theme'

export const DEVICE_STATUSES = ['online', 'offline', 'error', 'draft', 'virtual', 'sleep'] as const

export type DeviceStatus = typeof DEVICE_STATUSES[number]

export interface DashboardDeviceStat {
    label: DeviceStatus
    color: string
    key: DeviceStatus
    value: number
}

interface IDashboardDevicesData {
    stats: DashboardDeviceStat[] | null
    devicesCount: number
}

type DashboardDigitalSignageStatsResponse = Record<string, number> & {
    digitalSignageCount: number
}

const initialState: IDashboardDevicesData = {
    stats: null,
    devicesCount: 0,
}

const getColorForDevicesNumber = (key: DeviceStatus) => {
    switch (key) {
        case 'online':
            return `var(--var-module-dashboard-component-dashboard-style-online, ${defaultThemeDashboardStyles.online})`
        case 'error':
            return `var(--var-module-dashboard-component-dashboard-style-error, ${defaultThemeDashboardStyles.error})`
        case 'offline':
            return `var(--var-module-dashboard-component-dashboard-style-offline, ${defaultThemeDashboardStyles.offline})`
        case 'sleep':
            return `var(--var-module-dashboard-component-dashboard-style-sleep, ${defaultThemeDashboardStyles.sleep})`
        case 'virtual':
        case 'draft':
            return palette.neutral[400]
        default:
            return palette.neutral[400]
    }
}

function DashboardDevicesMethods() {
    const [data, setData] = useState<IDashboardDevicesData>(initialState)

    useEffect(() => {
        let isMounted = true

        api.send<object, DashboardDigitalSignageStatsResponse>(
            'dashboardGetDigitalSignageStats',
            {},
            { showEmitError: false }
        ).then((response) => {
            if (!isMounted) return

            const stats = DEVICE_STATUSES.map<DashboardDeviceStat>((status) => ({
                label: status,
                color: getColorForDevicesNumber(status),
                key: status,
                value: response[status] ?? 0,
            }))

            setData({ stats, devicesCount: response.digitalSignageCount })
        })

        return () => {
            isMounted = false
        }
    }, [])

    return {
        s_: {
            data,
        },
    }
}

export default DashboardDevicesMethods
